'use client';

import { OrderDetails } from './components/OrderDetails';
import { ThankYouHelpSection } from './components/ThankYouHelpSection';
import { ThankYouSuccessBanner } from './components/ThankYouSuccessBanner';
import { useCheckoutPurchaseConfirmation } from './hooks/useCheckoutPurchaseConfirmation';

function ThankYouContent() {
  const { purchaseConfirmation } = useCheckoutPurchaseConfirmation();

  return (
    purchaseConfirmation && (
      <main className="min-h-screen bg-background-primary sm-md:py-8" id="main-content" data-testid="thank-you-page" data-track-feature="Shopping Cart">
        <div
          className="w-full min-w-[350px] max-w-[350px] sm-md:min-w-0 sm-md:w-full sm-md:max-w-160 mx-auto bg-background sm-md:rounded-lg flex flex-col gap-6"
          data-track-container="Checkout Confirmation"
        >
          <ThankYouSuccessBanner />
          <OrderDetails orderDetails={purchaseConfirmation.orderDetails} products={purchaseConfirmation.products} pricing={purchaseConfirmation.pricing} />
          <ThankYouHelpSection />
        </div>
      </main>
    )
  );
}

export { ThankYouContent };
